const careersTestimonials = [
    {
        selector: '[data-testimonials]',
        path: { filename: 'careersTestimonials' },
    },
];

export { careersTestimonials };
